import React, { PropsWithChildren } from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const SwipeableViewsAutoPlay = autoPlay(
  SwipeableViews
) as React.ComponentType<any>;

const SwipableViews = ({ children }: PropsWithChildren) => {
  const customSpringConfig = {
    duration: "2s",
    easeFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)",
    delay: "1s",
  };
  return (
    <SwipeableViewsAutoPlay
      interval={5000}
      resistance
      springConfig={customSpringConfig}
    >
      {children}
    </SwipeableViewsAutoPlay>
  );
};

export default SwipableViews;
